// App Store URLs
export const APP_STORE_URLS = {
  ios: 'https://apps.apple.com',
  android: 'https://play.google.com'
}

// Common styles for shiny buttons
export const SHINY_BUTTON_STYLES = {
  base: {
    background: `
      linear-gradient(145deg, #2a2a2a 0%, #000000 50%, #1a1a1a 100%),
      linear-gradient(45deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 50%, transparent 100%)
    `,
    boxShadow: `
      inset 0 1px 0 rgba(255,255,255,0.2),
      inset 0 -1px 0 rgba(0,0,0,0.5),
      0 4px 8px rgba(0,0,0,0.3),
      0 0 0 1px rgba(255,255,255,0.1)
    `,
    transition: 'all 0.2s ease',
    cursor: 'pointer',
    position: 'relative',
    overflow: 'hidden'
  },
  hover: {
    boxShadow: `
      inset 0 1px 0 rgba(255,255,255,0.3),
      inset 0 -1px 0 rgba(0,0,0,0.5),
      0 6px 12px rgba(0,0,0,0.4),
      0 0 0 1px rgba(255,255,255,0.2)
    `
  },
  circular: {
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  rectangular: {
    padding: '12px 24px',
    borderRadius: '8px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: '600',
    fontSize: '14px',
    gap: '8px',
    color: 'white',
    textShadow: '0 1px 2px rgba(0,0,0,0.5)'
  }
}

// Card shadow styles
export const CARD_STYLES = {
  shadow: '0 4px 12px rgba(0,0,0,0.05)',
  borderRadius: '12px'
}

// Gradient styles for card headers
export const CARD_GRADIENTS = {
  green: 'linear-gradient(135deg, #389e0d 0%, #52c41a 100%)',
  blue: 'linear-gradient(135deg, #1890ff 0%, #40a9ff 100%)',
  purple: 'linear-gradient(135deg, #722ed1 0%, #9254de 100%)',
  orange: 'linear-gradient(135deg, #fa8c16 0%, #ffa940 100%)',
  lightBlue: 'linear-gradient(135deg, #91d5ff 0%, #bae7ff 100%)'
}
